var exports = {
  "sx": "Radio__awNbif",
  "z6": "RadioGroup__JeKSR1",
  "zy": "RadioText__HDDjKW",
};

module.exports = exports;
